import qs from 'qs'
import request from './request'

const _post = (url, data) => {
  return request({
    method: 'POST',
    url,
    data
  })
}

const _get = (url, data) => {
  return request({
    method: 'GET',
    url,
    params: data
  })
}

const _formget = (url, data) => {
  return request({
    method: 'GET',
    url,
    params: data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'text/plain' }
  })
}

const _formpost = (url, data) => {
  return request({
    method: 'POST',
    url,
    data: qs.stringify(data),
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'text/plain' }
  })
}

const _downpost = (url, data) => {
  return request({
    method: 'POST',
    url,
    data,
    responseType: 'blob'
  })
}

export { _post as NPOST, _get as NGET, _formpost as NFPOST, _formget as NFGET, _downpost as HREF }
